import { render, staticRenderFns } from "./selectPicByVoice.vue?vue&type=template&id=e7167336&scoped=true"
import script from "./selectPicByVoice.vue?vue&type=script&lang=js"
export * from "./selectPicByVoice.vue?vue&type=script&lang=js"
import style0 from "./selectPicByVoice.vue?vue&type=style&index=0&id=e7167336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7167336",
  null
  
)

export default component.exports